import base from '../common/base.js'

import Vue from 'vue'
import Router from 'vue-router'
import tabbar from "@/view/tabbar/index"
import jumpTab from "@/view/jumpTab/index"
import bookDetail from "@/view/bookDetail/index"
import bookCatalog from "@/view/bookCatalog/index"
import bookRead from "@/view/bookRead/index"
import bookCharge from "@/view/bookCharge/index"
import bookActivity from "@/view/bookActivity/index";
import bookClass from "@/view/bookClass/index";
import bookComplaint from "@/view/bookComplaint/index"
import bookConsume from "@/view/bookConsume/index"
import bookCurrency from "@/view/bookCurrency/index"
import bookFeedback from "@/view/bookFeedback/index"
import bookFree from "@/view/bookFree/index"
import bookFrency from "@/view/bookFrency/index";
import bookLastRead from "@/view/bookLastRead/index";
import bookList from "@/view/bookList/index"
import bookPhone from "@/view/bookPhone/index"
import bookRecharge from "@/view/bookRecharge/index"
import bookRecommandread from "@/view/bookRecommandread/index"
import bookRember from "@/view/bookRember/index"
import bookSearch from "@/view/bookSearch/index"
import bookSort from "@/view/bookSort/index"
import bookTaskone from "@/view/bookTaskone/index"
import bookWeb from "@/view/bookWeb/index"
import chooseAccount from "@/view/chooseAccount/index"
import chooseCoupons from "@/view/chooseCoupons/index"
import getCoupons from "@/view/getCoupons/index"
import index from "@/view/index/index"
import currencyOverdue from "@/view/currencyOverdue/index"
import moveSuccess from "@/view/moveSuccess/index"
import noAccount from "@/view/noAccount/index"
import playGames from "@/view/playGames/index"
import promotionLink from "@/view/promotionLink/index"
import QcodeMove from "@/view/QcodeMove/index"
import userCoupons from "@/view/userCoupons/index"
import winRecord from "@/view/winRecord/index"
import menuIndex from "@/view/menuIndex/index"
import bookFindpay from "@/view/bookFindPay/index"
import paySuccess from "@/view/paySuccess/index"
import wxContent from "@/view/wxHtml/wxContent"
import course from "@/view/wxHtml/course"
import bookModelActivity from "@/view/bookModelActivity/index";
import bookBuyManage from "@/view/bookBuyManage/index"
import drawCurrency from "@/view/drawCurrency/index"
import guideCode from "@/view/guideCode/index"
import giveCurrency from "@/view/giveCurrency/index"
import Privacy from "@/view/Privacy/index"
import agreement from "@/view/agreement/index"
Vue.use(Router)

export default new Router({
  routes: [{
      path: '',
      name: 'tabbar',
      component: tabbar,
      meta: {  noCache: false, keepAlive: true , isBack: false}
    },
    {
      path: '/pages/tabbar/index',
      name: 'jumpTab',
      component: jumpTab,
      meta: { title:'首页', noCache: false, keepAlive: false , isBack: false}
    },
    {
      path: '/pages/bookDetail/index',
      name: 'bookDetail',
      component: bookDetail,
      meta: { title:'书籍详情', noCache: false, keepAlive: false , isBack: false}
    },
    {
      path: '/pages/bookCatalog/index',
      name: 'bookCatalog',
      component: bookCatalog,
      meta: { title:'目录', noCache: false, keepAlive: false , isBack: false}
    },
    {
      path: '/pages/bookRead/index',
      name: 'bookRead',
      component: bookRead,
      meta: { title:'阅读器', noCache: false, keepAlive: false , isBack: false}
    },
    {
      path: '/pages/bookCharge/index',
      name: 'bookCharge',
      component: bookCharge,
      meta: { title:'充值中心',  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path: '/pages/bookActivity/index',
      name: 'bookActivity',
      component: bookActivity,
      meta: { title:'老活动', noCache: false, keepAlive: false , isBack: false}
    },
    {
      path: '/pages/bookModelActivity/index',
      name: 'bookModelActivity',
      component: bookModelActivity,
      meta: { title:'活动中心', noCache: false, keepAlive: false , isBack: false}
    },
    // bookModelActivity
    {
      path:'/pages/bookClass/index',
      name:'bookClass',
      component:bookClass,
      meta: { title:'分类', noCache: false, keepAlive: true , isBack: false}
    },
    {
      path:'/pages/bookComplaint/index',
      name:'bookComplaint',
      component:bookComplaint,
      meta: { title:'投诉',  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/bookConsume/index',
      name:'bookConsume',
      component:bookConsume,
      meta: { title:'消费记录',  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/bookCurrency/index',
      name:'bookCurrency',
      component:bookCurrency,
      meta: {  title:'书币',  noCache: false, keepAlive: false , isBack: false}
    }
    ,
    {
      path:'/pages/bookFeedback/index',
      name:'bookFeedback',
      component:bookFeedback,
      meta: { title:'意见反馈',   noCache: false, keepAlive: false , isBack: false}
    }
    ,
    {
      path:'/pages/bookFree/index',
      name:'bookFree',
      component:bookFree,
      meta: {  title:'限时免费', noCache: false, keepAlive: true , isBack: false}
    },
    {
      path:'/pages/bookFrency/index',
      name:'bookFrency',
      component:bookFrency,
      meta: {  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/bookLastRead/index',
      name:'bookLastRead',
      component:bookLastRead,
      meta: { title:'最近阅读', noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/bookList/index',
      name:'bookList',
      component:bookList,
      meta: {title:'猜你喜欢',  noCache: false, keepAlive: true , isBack: false}
    }
    ,
    {
      path:'/pages/bookPhone/index',
      name:'bookPhone',
      component:bookPhone,
      meta: {  title:'绑定手机', noCache: false, keepAlive: false , isBack: false}
    }
    ,
    {
      path:'/pages/bookRecharge/index',
      name:'bookRecharge',
      component:bookRecharge,
      meta: { title:'充值记录',  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/bookRecommandread/index',
      name:'bookRecommandread',
      component:bookRecommandread,
      meta: { title:'章末推荐',  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/bookRember/index',
      name:'bookRember',
      component:bookRember,
      meta: {title:'会员中心',  noCache: false, keepAlive: true , isBack: false}
    },
    {
      path:'/pages/bookSearch/index',
      name:'bookSearch',
      component:bookSearch,
      meta: { title:'搜索页', noCache: false, keepAlive: true , isBack: false}
    },
    {
      path:'/pages/bookSort/index',
      name:'bookSort',
      component:bookSort,
      meta: {  title:'排行榜',noCache: false, keepAlive: true , isBack: false}
    },
    {
      path:'/pages/bookTaskone/index',
      name:'bookTaskone',
      component:bookTaskone,
      meta: {  title:'任务中心', noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/bookWeb/index',
      name:'bookWeb',
      component:bookWeb,
      meta: { title:'网页', noCache: false, keepAlive: false , isBack: false}
      
    },{
      path:'/pages/chooseAccount/index',
      name:'chooseAccount',
      component:chooseAccount,
      meta: {  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/chooseCoupons/index',
      name:'chooseCoupons',
      component:chooseCoupons,
      meta: {  title:'选择优惠券',noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/getCoupons/index',
      name:'getCoupons',
      component:getCoupons,
      meta: { title:'获取优惠券', noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/index/index',
      name:'index',
      component:index,
      meta: {  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/currencyOverdue/index',
      name:'currencyOverdue',
      component:currencyOverdue,
      meta: { title:'过期记录',  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/moveSuccess/index',
      name:'moveSuccess',
      component:moveSuccess,
      meta: {  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/noAccount/index',
      name:'noAccount',
      component:noAccount,
      meta: {  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/playGames/index',
      name:'playGames',
      component:playGames,
      meta: {  title:'抽奖页面', noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/promotionLink/index',
      name:'promotionLink',
      component:promotionLink,
      meta: {  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/QcodeMove/index',
      name:'QcodeMove',
      component:QcodeMove,
      meta: {  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/userCoupons/index',
      name:'userCoupons',
      component:userCoupons,
      meta: { title:'我的优惠券', noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/winRecord/index',
      name:'winRecord',
      component:winRecord,
      meta: {  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/menuIndex/index',
      name:'menuIndex',
      component:menuIndex,
      meta: {  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/bookFindpay/index',
      name:'bookFindpay',
      component:bookFindpay,
      meta: {  noCache: false, keepAlive: false , isBack: false}
    }
    ,
    {
      path:'/pages/paySuccess/index',
      name:'paySuccess',
      component:paySuccess,
      meta: {  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/bookBuyManage/index',
      name:'bookBuyManage',
      component:bookBuyManage,
      meta: {  noCache: false, keepAlive: false , isBack: false}
    }
    ,
    {
      path:'/wxContent',
      name:'wxContent',
      component:wxContent,
      meta: {  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/course',
      name:'course',
      component:course,
      meta: {  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/drawCurrency/index',
      name:'drawCurrency',
      component:drawCurrency,
      meta: {title:'微信VIP读者福利',  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/guideCode/index',
      name:'guideCode',
      component:guideCode,
      meta: { title:'导粉页', noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/giveCurrency/index',
      name:'giveCurrency',
      component:giveCurrency,
      meta: {  title:'读者福利',  noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/Privacy/index',
      name:'Privacy',
      component:Privacy,
      meta: { title:'隐私政策', noCache: false, keepAlive: false , isBack: false}
    },
    {
      path:'/pages/agreement/index',
      name:'agreement',
      component:agreement,
      meta: {  title:'用户协议',noCache: false, keepAlive: false , isBack: false}
    }
    // giveCurrency
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

 

  

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  console.log(location)
   return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js